"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Yup = __importStar(require("yup"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_context_req_ctx_1 = require("@hotelplan/libs.context.req-ctx");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const B2BMarkupForm_utils_1 = require("./B2BMarkupForm.utils");
const formItemStyles = {
    width: '150px',
    height: '52px',
};
const MarkupFormValidationSchema = Yup.object({
    markup: Yup.number().min(0).required('forms:errors.required').integer(),
});
const MarkupFormWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    zIndex: 10,
    display: 'inline-block',
    top: 'calc(100% + 5px)',
    left: '50%',
    transform: 'translateX(-50%)',
    '.markup-control-button': {
        display: 'flex',
        borderRadius: '50%',
        background: 'white',
        boxShadow: 'tooltip',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 4,
        span: {
            height: '40px', // adjust font shift
        },
    },
    '&, > button': {
        width: '20px',
        height: '20px',
    },
}));
const FormWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: 4,
    py: 3,
    zIndex: 4,
    position: 'absolute',
    borderTop: '1px solid',
    display: 'inline-block',
    boxShadow: 'landDropdown',
    borderColor: 'borderColor',
    top: 'calc(100% + 10px)',
    right: 'calc(100% - 20px)',
    backgroundColor: 'markupForm',
}));
const FormContentWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    '.form-item-validate': Object.assign(Object.assign({}, formItemStyles), { width: '250px', mr: 3 }),
    '.form-item-submit': formItemStyles,
}));
const SubmitButtonWrapper = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    type: 'submit',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    px: 3,
}));
const B2BMarkupForm = () => {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const [t] = (0, next_i18next_1.useTranslation)('forms');
    const { b2bMarkup } = (0, libs_context_req_ctx_1.useRequestContext)();
    const [isFormOpened, , , toggleForm] = (0, libs_hooks_react_1.useToggleState)(false);
    const onMarkupApply = (values) => {
        (0, B2BMarkupForm_utils_1.setB2BMarkupCookie)(values.markup);
        requestAnimationFrame(() => {
            window.location.href = `${window.location.href}`;
        });
    };
    const onMarkupControlClick = () => {
        toggleForm();
    };
    if (mobile)
        return null;
    return (react_1.default.createElement(MarkupFormWrapper, null,
        react_1.default.createElement("button", { "data-id": "markup-control", onClick: onMarkupControlClick, className: "markup-control-button" },
            react_1.default.createElement("span", null, isFormOpened ? '-' : '+')),
        isFormOpened && (react_1.default.createElement(FormWrapper, null,
            react_1.default.createElement(formik_1.Formik, { initialValues: {
                    markup: b2bMarkup || 0,
                }, onSubmit: onMarkupApply, validationSchema: MarkupFormValidationSchema }, formik => {
                return (react_1.default.createElement("form", { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
                    react_1.default.createElement(FormContentWrapper, null,
                        react_1.default.createElement("div", { className: "form-item-validate" },
                            react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { hideLabel: true, name: "markup", autoComplete: "given-name" })),
                        react_1.default.createElement("div", { className: "form-item-submit" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(SubmitButtonWrapper, null, t('forms:apply.button')))))));
            })))));
};
exports.default = B2BMarkupForm;
//# sourceMappingURL=B2BMarkupForm.js.map